<template>
  <div
    @click.stop="click"
    class="item-book row-menu"
    :class="{ selected: book.id == bookSelectedId }"
  >
    <span v-show="book.id == bookSelectedId" class="font-icon check-icon"
      >A</span
    >

    <div class="container-text-item">
      <nameBook :name="getName" />
      <nameAuthor :name="book.mainAuthorName" />
    </div>
    <div
      class="next"
      @click="$emit('change')"
      v-tooltip="{
        content: this.$t('changeBookInfo.selectBook'),
        placement: 'right',
      }"
    >
      <baseIcon
        width="9.451"
        height="7.516"
        pathIcon="icons"
        nameIcon="arrow-advanced-search-black"
      />
    </div>
  </div>
</template>

<script>
import { getBookName } from "@/services/bookData.js";
import nameBook from "@/components/listBookArea/listContentContainer/nameBook.vue";
import nameAuthor from "@/components/listBookArea/listContentContainer/nameAuthor.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    book: Object,
    isCheck: Boolean,
    bookSelectedId: Number,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("books", ["getBookbyId"]),
    getName() {
      return getBookName(this.book.name, this.book.volume, true);
    },
  },
  components: {
    nameBook,
    nameAuthor,
  },
  methods: {
    ...mapActions("tabsManager", ["setBook"]),
    ...mapActions("booklistComp", ["addListBooks"]),

    click() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
$bg-hover1: #00000014;
body {
  direction: rtl;
  text-align: right;
}
.item-book {
  display: flex;
  width: 100%;
  height: 37px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 3px 0 11px;
  line-height: 37px;
  color: #000;
  font-size: 13px;
  cursor: pointer;
  direction: rtl;
  max-width: 100%;
  align-items: center;
  &.item-vol {
    padding-right: 32px;
  }
  label {
    padding: 8px;
  }
  .container-text-item {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 15px);
    width: 100%;
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    padding: 0 10px 0 0;
    display: block;
  }
  .check-item {
    opacity: 1;
    transition: 0.3s;
  }
}
.item-vol {
  // padding: 0 32px;
  background-color: rgba(0, 0, 0, 0.05);
}
.show-sum-vol {
  border-radius: 50%;
  height: 21px;
  width: 21px;
  display: block;
  font-size: 12px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  line-height: 21px;
  position: relative;
  &.open {
    .close {
      opacity: 1;
      transition: 0.3s;
      display: block;
    }
  }
  .close {
    opacity: 0;
    transition: 0.3s;
    display: block;
  }
  &:hover:not(.open) {
    .num {
      opacity: 0;
      display: none;
    }
    .close {
      display: block;
      opacity: 1;
      transform: rotate(45deg);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9;
    }
  }
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    margin-top: -1px;
    margin-left: 1px;
  }
}
.item-book:hover,
.item-book.selected,
.item-book.active {
  box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0,
    0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  // border: 1px solid #d4d4d4;
  border-left: 0;
  border-right: 0;
  .font-icon,
  .name-book,
  .name-author {
    color: var(--custom-color1);
  }
  .next {
    visibility: visible;
  }
  // background-color: var(--text-color7);
}
.item-book .name-book {
  color: #000;
  font-size: 13px;
  font-weight: bold;
}
.next {
  height: 21px;
  width: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(119, 119, 119);
  border-radius: 50%;
  visibility: hidden;
  transition: 0.3s;
  &:hover {
    transform: translateX(-1.5px);
    transition: 0.3s;
  }
}
</style>
